import { render, staticRenderFns } from "./compatibility.vue?vue&type=template&id=18ef28ef&"
import script from "./compatibility.vue?vue&type=script&lang=ts&"
export * from "./compatibility.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports